import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../pages/Applicant.css";
import { UserContextComponent } from "../UserContextComponent";
import axios from "axios";
import { ILenderProduct } from "../../models/CalculatorModels";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import { NextButton } from "../NextButton";
import { NumberAsCurrency } from "../NumberAsCurrency";

interface IProps {
  item?: ILenderProduct;
  repayment?: number;
  className?: string;
}

export class CalculatedLenderProductRow extends UserContextComponent<
  IProps,
  any
> {
  constructor(props: IProps) {
    super(props);
  }

  fixedYearText(product: ILenderProduct): any {
    var rateText = "";
    if (!product) return "";
    if (product.fixedYears > 0) {
      rateText = `${product.fixedYears} year, ${product.type}`;
      if (rateText.endsWith("rate")) {
        rateText = rateText.replace("rate", "");
      }
    } else {
      rateText = product.type;
    }
    return rateText;
  }

  render() {
    var item = this.props.item;
    if (!item) return <></>;
    return (
      <>
        <Row
          className={`desktop-only m-2 box-teal-outline-1 px-0 ${
            this.props.className ?? ""
          }`}
        >
          <Col className="w-20 border-left-curved bg-white border-teal border-right-teal p-0 justify-center py-5">
            {item.lenderLogo ? (
              <img
                className=""
                style={{
                  height: "60px",
                  marginTop: -5,
                }}
                src={item.lenderLogo}
              ></img>
            ) : (
              <h1>{item.lenderName}</h1>
            )}
          </Col>

          <Col className="w-40 border-right p-0 py-5 border-right-teal pe-5 px-4">
            <Row>
              <Col xs={6} className="ps-5">
                <p className="mb-0">Type:</p>
                <p className="mt-0 impact">{<>{this.fixedYearText(item)}</>}</p>
              </Col>
              <Col xs={6}>
                <p className="mb-0">
                  {item.minBer && item.minBer <= 755980005
                    ? "Green Rate:"
                    : "Rate:"}
                </p>
                <p className="mt-0 impact">{item.rate + "%"}</p>
                {item.cashback && item.cashbackAmount && (
                  <CashbackStamp item={item} />
                )}
              </Col>
            </Row>
          </Col>

          <Col className="w-40 border-right-curved justify-center bg-chartreuse">
            <Row className="justify-center ms-5">
              <Col className=" p-0">
                <p className="nowrap text-start tight">Monthly repayment</p>
                <h2 className="impact tight">
                  <NumberAsCurrency value={item.repayment} />
                </h2>
              </Col>

              {/* <Col className="text-end ms-5">
                <Stack gap={2}>
                  <Link to="/profile" className=" a-s-e">
                    <button className="btn btn-primary btn-wider big btn-dark chartreuse-font ps-3 text-start">
                      <i className="far fa-circle-right fa-xl pe-2" />{" "}
                      <strong>Continue</strong>
                    </button>
                  </Link>
                  <Link to="#" className=" a-s-e">
                    <button className="btn btn-primary btn-wider big btn-standard nowrap ps-3 text-start">
                      <i className="far fa-calendar-days fa-xl pe-2" /> Book a
                      FREE call
                    </button>
                  </Link>
                </Stack>
              </Col> */}
            </Row>
          </Col>
        </Row>

        {/* Mobile Mode - it's completely different so just put it in it's own row */}
        <Row
          className={`mobile-only m-2 box-teal-outline-1 p-0 ${
            this.props.className ?? ""
          }`}
        >
          <Row className="m-0 border-top-curved bg-white border-bottom-teal py-3 text-start">
            {item.lenderLogo ? (
              <img
                className=""
                style={{
                  width: "160px",
                  marginTop: -5,
                }}
                src={item.lenderLogo}
              ></img>
            ) : (
              <h1>{item.lenderName}</h1>
            )}
          </Row>

          <Row className="m-0 p-0">
            <Col className="border-bottom-left-curved border-right p-0 justify-center py-4 border-right-teal">
              <p className="mb-0">Type:</p>
              <p className="mt-0 impact">{<>{this.fixedYearText(item)}</>}</p>
              <p className="mb-0">
                {item.minBer && item.minBer <= 755980005
                  ? "Green Rate:"
                  : "Rate:"}
              </p>
              <p className="mt-0 impact">{item.rate + "%"}</p>
              {item.cashback && item.cashbackAmount && (
                <CashbackStamp item={item} />
              )}
            </Col>

            <Col
              className="border-bottom-right-curved justify-center bg-chartreuse pe-5 m-0"
              style={{ width: "60%" }}
            >
              <Row className="justify-center ms-5 p-0 me-0">
                <Col className=" p-0">
                  <p className="text-start tight nowrap">Monthly repayment</p>
                  <h2 className="impact tight">
                    <NumberAsCurrency value={item.repayment} />
                  </h2>
                </Col>
              </Row>
            </Col>
          </Row>
        </Row>
      </>
    );
  }
}

function CashbackStamp({ item }: { item: ILenderProduct }) {
  return (
    <>
      <div className="stamp-container">
        <div className="stamp bg-chartreuse justify-center">
          <p className="s p-0 m-0">
            {!item.fixedCashback && `${item.cashback}%`} Cashback
          </p>
          <p className="impact p-0 m-0">
            <NumberAsCurrency value={item.cashbackAmount} />
          </p>
        </div>
      </div>
    </>
  );
}
